<template>
    <div id="contenedor-formulario-edictos" class="container-fluid p-0">
        <div id="formulario" class="row">
            <div id="campos-formulario" class="col-xs-6 col-sm-6 col-md-6 col-lg-6 pt-1 pr-2">
                <div id="contenedor-campos">
                    <h2>Formulado de envió</h2>
                    <!-- INPUT REMITENTE -->
                    <div class="form-group mt-4">
                        <h6>Remitente (*)</h6>
                        <div class="input-group">
                            <div class="input-group-append">
                                <div class="input-group-text"><i class="fas fa-mail-bulk"></i></div>
                            </div>
                            <input class="form-control input-sm input-xs input-md input-lg py-2 border-left-0 border" type="text" placeholder="Nombre del remitente">
                        </div>
                    </div>
                    <!-- INPUT JUZGADO -->
                    <div class="form-group">
                        <h6>Juzgado (*)</h6>
                        <select class="form-control">
                            <option value="-1">Seleccione un juzgado</option>
                            <option value="1">Primero familiar</option>
                            <option value="2">Primero mercantil</option>
                        </select>  
                    </div>
                    <!-- COMENTARIOS -->
                    <div class="form-group">
                        <h6>Comentarios u observaciones </h6>
                        <textarea  
                             type="text" id="descripcion_contenido" 
                            :class="[false ? 'form-control border border-danger': 'form-control']" placeholder="Comentarios u observaciones" />
                    </div>
                    <!-- ARCHVIO -->
                    <div class="form-group">
                        <h6>Anexar archivo (*)</h6>
                         <input 
                            type="file" id="imagen_contenido" 
                            :class="[ false ? 'form-control border border-danger': 'form-control']" accept=".PDF" />
                    </div>
                    <!-- ACCIONES -->
                    <div id="acciones-formulario" class="form-group">
                        <div class="d-flex justify-content-end"><button class="btn btn-primary mt-3" @click="evtEnviar">Enviar</button></div>
                    </div>
                </div>
            </div>
            <!-- INSTRUCCIONES -->
            <div id="instrucciones" class="col-xs-6 col-sm-6 col-md-6 col-lg-6 pt-1 pr-2">
                <div class="alert alert alert-secondary text-justify" role="alert">
                    <h4 class="alert-heading"><i class="fas fa-info-circle"></i>&nbsp;<strong>NOTA</strong></h4>
                    <hr>
                    <h6>Los campos marcados con un (*) son obligatorios.
                    Al presionar el botón de enviar, comenzará el proceso de carga del archivo.
                    El tiempo de espera dependerá del tamaño del archivo y de su conexión a internet, por favor espere hasta que aparezca el mensaje de confirmación.</h6>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        opciones: {
            type: Object,
            default: () => ({ 
                conEstilosDefault: { mostrar: true, estiloCssNuevo: '' }
            })
        },
    },
    methods: {
        evtEnviar: function() {
            this.$emit('enviar', {valor: 2})
        }
    },
}
</script>
<style scoped>
#acciones-formulario .btn-primary:focus, #acciones-formulario .btn-primary:hover {
    background-color: black;
    color: #be9a5e;
}

#instrucciones h6 {
    color: #676666;
    font-weight: bold;
    font-size: 2vmin;
}

#contenedor-campos {
    border: 1px solid #AF9C9C;
    border-radius: 1em;
    background-color: #b1b1b1;
    padding: 1em 2em 1em 2em;
    color: #424242;
}

#contenedor-campos h2 {
    font-size: 4vmin;
    font-weight: bold;
}

#contenedor-campos h6 {
    font-size: 2.3vmin;
}

#contenedor-campos .form-control {
    background-color: white;
    color: rgb(63, 62, 62);
    border: 1px solid #656161 !important;
    height: 2.5em;
}

#contenedor-campos textarea {
    height: 8em !important;
    padding-top: 0.5em;
}

#contenedor-campos .input-group-text {
    border-top-left-radius: 0.6vmin;
    border-bottom-left-radius: 0.6vmin;
}

#contenedor-campos .form-control:focus {
    box-shadow: none;
}

#contenedor-campos .form-control::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #AF9C9C;
  opacity: 1; /* Firefox */
  font-weight: bold;
}

#contenedor-campos .form-control:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: #AF9C9C;
  opacity: 1; /* Firefox */
  font-weight: bold;
}

#contenedor-campos .form-control::-ms-input-placeholder { /* Microsoft Edge */
  color: #AF9C9C;
  opacity: 1; /* Firefox */
  font-weight: bold;
}

#contenedor-campos .input-group-text {
    background-color: #676666;
    color: #FFFFFF;
    border: 1px solid #656161;
}
</style>


// WEBPACK FOOTER //
// src/components/Intranet/Formatos/CFormularioEnvioEdictos.vue